export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fish.vue?vue&type=template&id=5091bb28"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/fish.vue?vue&type=template&id=5091bb28
// module id = fUio
// module chunks = 0